<template>
    <ckeditor 
        :editor="editor" 
        v-model="hidden_value" 
        :config="conf"
        @input="onEditorInput"
    />
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
    props: ['value'],
    data() {
        return {
            editor: ClassicEditor,
            conf: {},
            hidden_value: this.value
        }
    },
    methods: {
        onEditorInput(e) {
            this.$emit('input', e)
        }
    }
}
</script>

<style>
    .ck-editor {
        min-height: 180px;
    }
    .ck-editor__main {
        min-height: 180px;
    }
    .ck-editor__editable {
        min-height: 180px;
    }
</style>